<!-- KYMW4400 ページ・台割編集 -->
<div class="contents-area">
  <div class="element-column">
    <div class="block-row">
      <div class="column-list">
        <!-- 媒体 -->
        <label class="list-input-title">媒体</label>
        <div class="list-input-content">
          <app-koma-medium-type-combo-box #cmb_MediumType id="cmb_MediumType" [width]="280" [required]="true"
            [forcedEnabledMode]="'true'" [(ngModel)]="model.mediumType" [tabindex]="0">
          </app-koma-medium-type-combo-box>
        </div>
      </div>
      <div class="column-list" style="width: 360px;">
        <!-- 受注コード -->
        <label class="list-input-title">受注コード</label>
        <div class="list-input-content">
          <app-order-text-with-catalog #txti_OrderCode id="txti_OrderCode" [autofocus]="true" [required]="true"
            [tabindex]="0" [forcedEnabledMode]="'true'" [(ngModel)]="model.orderCode" [width]="'7rem'"
            (onChangedCatalogId)="model.catalogId = $event">
          </app-order-text-with-catalog>
        </div>
      </div>
      <div class="column-list">
        <!-- 企画回 -->
        <label class="list-input-title">企画回</label>
        <div class="list-input-content">
          <app-catalog-text-with-order #txti_CatalogId id="txti_CatalogId" [autofocus]="true" [required]="true"
            [tabindex]="0" [forcedEnabledMode]="'true'" [(ngModel)]="model.catalogId"
            (onChangedOrderCode)="model.orderCode = $event" class="deliv-catalog">
          </app-catalog-text-with-order>
        </div>
      </div>
      <div class="column-list">
        <!-- 会員生協 -->
        <label class="list-input-title">会員生協</label>
        <div class="list-input-content">
          <app-coop-code-combo-box #cmb_CoopCode id="cmb_CoopCode" [width]="230" [required]="true"
            [forcedEnabledMode]="'true'" [(ngModel)]="model.coopCode" [tabindex]="0"></app-coop-code-combo-box>
        </div>
      </div>
    </div><!-- END div block-row -->
    <div class="block-row">
      <div class="column-list" style="width: 410px;">
        <!-- コピー元受注コード -->
        <label class="list-input-title">コピー元受注コード</label>
        <div class="list-input-content" style="width: 7rem;">
          <input type="text" id="lbl_OrderCodeOrigin" plessInputTextSub
            [(ngModel)]="model.originalOrderCode" readonly/>
        </div>
      </div>
      <div class="column-list">
        <!-- コピー元生協コード -->
        <label class="list-input-title">コピー元生協コード</label>
        <div class="list-input-content" style="width: 230px;">
          <input type="text" id="lbl_CoopCodeOrigin" plessInputTextSub
            [(ngModel)]="model.originalCoopCode" readonly/>
        </div>
      </div>
    </div>
    <div class="layout_balance">
      <!-- button 表示 -->
      <button #btn_GetList id="btn_GetList" class='btn-secondary' forcedEnabledMode="true" (click)="getList()"
        [tabindex]="0">表示</button>
      <!-- button コピー -->
      <button #btn_Copy id="btn_Copy" class='btn-secondary' (click)="copy()" [tabindex]="0"
        [disabled]="!model.mediumType || isPermittedReadOnly">コピー</button>
    </div>
  </div>
  <div class="grid-container element-column">
    <!-- FlexGrid -->
    <wj-flex-grid #dtg_PageList id="dtg_PageList" [itemsSource]="model.pageList" [headersVisibility]="'All'"
      [selectionMode]="'Row'" horizontalScrollPolicy="on" verticalScrollPolicy="on" [allowSorting]="false"
      [allowResizing]="'Columns'" [allowDragging]="'Rows'" [autoScroll]="true" [frozenColumns]="4"
      (draggingRow)="onDraggingRow(dtg_PageList, $event)" (draggedRow)="onDraggedRow(dtg_PageList, $event)"
      (initialized)="gridInit(dtg_PageList)">
      <!-- チェックボックス -->
      <wj-flex-grid-column [header]="''" [width]="50" [binding]="'check'" [align]="'center'" [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'">
          <input #chk_Header [disabled]="!model.isEditable || isPermittedReadOnly" type="checkbox" class="selected header-checkbox"
            (click)="$event.stopPropagation();headerCheck();" [tabindex]="-1" />
        </ng-template>
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <input type="checkbox" class="selected" [disabled]="!model.isEditable || isPermittedReadOnly"
            [(ngModel)]="cell.item.check" (click)="$event.stopPropagation()" [tabindex]="-1" />
        </ng-template>
      </wj-flex-grid-column>
      <!-- ページNO -->
      <wj-flex-grid-column [header]="'ページ\nNO'" [multiLine]="true" [width]="60" [binding]="'pageNum'"
        [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell" [forceFullEdit]="true">
          <input class="text-label-required grid-inner-ele" type="text" plessInputTextSub
            [disabled]="!model.isEditable || isPermittedReadOnly" [halfOnly]="true" [restrict]="'[0-9]'"
            [(ngModel)]="cell.item.pageNum" [maxlength]="3" [tabindex]="-1"
            (blur)="pageNumBlur($event,cell.item.pageId)">
        </ng-template>
      </wj-flex-grid-column>
      <!-- ノンブル -->
      <wj-flex-grid-column [header]="'ノンブル'" [width]="60" [binding]="'folio'" [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell" [forceFullEdit]="true">
          <input class="text-label-required grid-inner-ele" type="text" plessInputTextSub
            [disabled]="!model.isEditable || isPermittedReadOnly" [halfOnly]="true" [restrict]="'[0-9]'"
            [(ngModel)]="cell.item.folio" [maxlength]="3" [tabindex]="-1" (blur)="folioBlur($event,cell.item.pageId)">
        </ng-template>
      </wj-flex-grid-column>
      <!-- ページ名称 -->
      <wj-flex-grid-column [header]="'ページ名称'" [width]="250" [binding]="'pageInfo'" [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell" [forceFullEdit]="true">
          <input class="text-label-required grid-inner-ele" type="text" plessInputTextSub
            [disabled]="!model.isEditable || isPermittedReadOnly" [(ngModel)]="cell.item.pageInfo" [maxlength]="25"
            restrict="[ -￮]" [tabindex]="-1" (focus)="pageInfoFocus(cell.item.pageInfo)">
        </ng-template>
      </wj-flex-grid-column>
      <!-- WEBカタログ用目次 -->
      <wj-flex-grid-column [header]="'WEBカタログ用目次'" [width]="150" [binding]="'webCatalogTitle'" [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell" [forceFullEdit]="true">
          <input class="grid-inner-ele" type="text" plessInputTextSub
            [disabled]="!model.isEditable || isPermittedReadOnly" [(ngModel)]="cell.item.webCatalogTitle"
            restrict="[ -￮]" [maxlength]="25" [tabindex]="-1">
        </ng-template>
      </wj-flex-grid-column>
      <!-- ページテンプレート -->
      <wj-flex-grid-column [header]="'ページテンプレート'" [width]="150" [binding]="'pageTemplateId'" [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box [(ngModel)]="cell.item.pageTemplateId" [listSource]="model.pageTemplateSelectItems"
            valueField="Code" labelField="Name" [disabled]="!model.isEditable || isPermittedReadOnly || cell.item.autoArrangePattern === '003'" [required]="true"
            [tabindex]="-1" [visible]="true" [autofocus]="false" (onChangedInvalid)="cell.item.pageTemplateId = ''"
            (change)="pageTemplateChange($event)">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <!-- ページ担当者１ -->
      <wj-flex-grid-column [header]="'ページ担当者１'" [width]="150" [binding]="'contactUser1'" [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box [(ngModel)]="cell.item.contactUser1" [listSource]="model.contactUserSelectItems"
            valueField="Code" labelField="Name" [disabled]="!model.isEditable || isPermittedReadOnly" [required]="true"
            [tabindex]="-1" [dspBothField]="true" [visible]="true" [autofocus]="false"
            (onChangedInvalid)="cell.item.contactUser1 = ''">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <!-- ページ担当者２ -->
      <wj-flex-grid-column [header]="'ページ担当者２'" [width]="150" [binding]="'contactUser2'" [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box [(ngModel)]="cell.item.contactUser2" [listSource]="model.contactUserSelectItems"
            valueField="Code" labelField="Name" [disabled]="!model.isEditable || isPermittedReadOnly" [required]="false"
            [tabindex]="-1" [dspBothField]="true" [visible]="true" [blank]="true" [autofocus]="false"
            (onChangedInvalid)="cell.item.contactUser2 = ''"
            (ngModelChange)="cell.item.contactUser2 = blankValChangeEmpty(cell.item.contactUser2)">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <!-- ページ担当者３ -->
      <wj-flex-grid-column [header]="'ページ担当者３'" [width]="150" [binding]="'contactUser3'" [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box [(ngModel)]="cell.item.contactUser3" [listSource]="model.contactUserSelectItems"
            [blank]="true" valueField="Code" labelField="Name" [disabled]="!model.isEditable || isPermittedReadOnly"
            [required]="false" [dspBothField]="true" [tabindex]="-1" [visible]="true" [autofocus]="false"
            (onChangedInvalid)="cell.item.contactUser3 = ''" 
            (ngModelChange)="cell.item.contactUser3 = blankValChangeEmpty(cell.item.contactUser3)">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <!-- 自動コマ割パターン -->
      <wj-flex-grid-column [header]="'自動コマ割\nパターン'" [multiLine]="true" [width]="120" [binding]="'autoArrangePattern'"
        [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box [(ngModel)]="cell.item.autoArrangePattern"
            [listSource]="model.autoArrangePatternSelectItems" valueField="CodeValue" labelField="CodeName"
            [blank]="true" [blankVal]="''" [disabled]="!model.isEditable || isPermittedReadOnly" [required]="cell.item.isAutoArrangePatternRequired"
            [visible]="true" [autofocus]="false" (onChangedInvalid)="cell.item.autoArrangePattern = ''" [tabindex]="-1"
            (ngModelChange)="cell.item.autoArrangePattern = blankValChangeEmpty(cell.item.autoArrangePattern)">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <!-- 掲載商品グループ -->
      <wj-flex-grid-column [header]="'掲載商品グループ'" [width]="150" [binding]="'dspPublishGoodsGroupNameList'"
        [isReadOnly]="true" [minWidth]="5">
      </wj-flex-grid-column>
      <!-- 掲載商品グループ ボタン -->
      <wj-flex-grid-column [header]="' '" [width]="70" [binding]="'publishGoodsGroupIdList'" [isReadOnly]="true"
        [align]="'center'" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <button class="btn-secondary grid-inner-secondary" (click)="setPublishGoodsGroup(cell.item.pageId)"
            [disabled]="!model.isEditable || isPermittedReadOnly">選択</button>
        </ng-template>
      </wj-flex-grid-column>
      <!-- 特集１ -->
      <wj-flex-grid-column [header]="'特集１'" [width]="150" [binding]="'feature1'" [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box [(ngModel)]="cell.item.feature1" [listSource]="model.featureSelectItems"
            valueField="Code" labelField="Name" [disabled]="!model.isEditable || isPermittedReadOnly" [required]="false"
            [tabindex]="-1" [dspBothField]="true" [visible]="true" [blank]="true" [autofocus]="false"
            (ngModelChange)="cell.item.feature1 = blankValChangeEmpty(cell.item.feature1);"
            (onChangedInvalid)="cell.item.feature1 = ''">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <!-- 特集２ -->
      <wj-flex-grid-column [header]="'特集２'" [width]="150" [binding]="'feature2'" [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box [(ngModel)]="cell.item.feature2" [listSource]="model.featureSelectItems"
            valueField="Code" labelField="Name" [disabled]="!model.isEditable || isPermittedReadOnly" [required]="false"
            [tabindex]="-1" [dspBothField]="true" [visible]="true" [blank]="true" [autofocus]="false"
            (ngModelChange)="cell.item.feature2 = blankValChangeEmpty(cell.item.feature2);"
            (onChangedInvalid)="cell.item.feature2 = ''">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <!-- 特集３ -->
      <wj-flex-grid-column [header]="'特集３'" [width]="150" [binding]="'feature3'" [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box [(ngModel)]="cell.item.feature3" [listSource]="model.featureSelectItems"
            valueField="Code" labelField="Name" [disabled]="!model.isEditable || isPermittedReadOnly" [required]="false"
            [tabindex]="-1" [dspBothField]="true" [visible]="true" [blank]="true" [autofocus]="false"
            (ngModelChange)="cell.item.feature3 = blankValChangeEmpty(cell.item.feature3);"
            (onChangedInvalid)="cell.item.feature3 = ''">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <!-- タグ -->
      <wj-flex-grid-column [header]="'タグ'" [width]="150" [binding]="'dspTagNameList'" [isReadOnly]="true" [minWidth]="5">
      </wj-flex-grid-column>
      <!-- タグ ボタン -->
      <wj-flex-grid-column [header]="' '" [width]="70" [binding]="'tagIdList'" [isReadOnly]="true" [align]="'center'" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <button class="btn-secondary grid-inner-secondary" (click)="setTag(cell.item.pageId)"
            [disabled]="!model.isEditable || isPermittedReadOnly">選択</button>
        </ng-template>
      </wj-flex-grid-column>
      <!-- 共通版 -->
      <wj-flex-grid-column [header]="'共通版'" [width]="100" [binding]="'commonPublishFlg'" [isReadOnly]="true" [minWidth]="5">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box [(ngModel)]="cell.item.commonPublishFlg"
            [listSource]="model.commonPublishFlgSelectItems" valueField="CodeValue" labelField="CodeName"
            [disabled]="!model.isEditable || isPermittedReadOnly" [required]="true" [tabindex]="-1" [visible]="true"
            [autofocus]="false" (onChangedInvalid)="cell.item.commonPublishFlg = ''">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
    </wj-flex-grid>
    <div class="element-row">
      <!-- button 行削除 -->
      <button #btn_delRow class='btn-tartiary warning' (click)="delRow()" [tabindex]="0"
        [disabled]="!model.isEditable || isPermittedReadOnly || !model.hasChecked">行削除</button>
      <!-- button 行追加 -->
      <button #btn_AddRow class='btn-secondary' (click)="addRow()" [tabindex]="0"
        [disabled]="!model.isEditable || isPermittedReadOnly">行追加</button>
    </div>
  </div><!-- div grid-container END -->

</div>

<footer class="footer-buttons">
  <!-- button コマ割実行 -->
  <button #btn_RegistKoma class='btn-secondary' (click)="registKoma()" [tabindex]="0"
    [disabled]="!model.isEditable || isPermittedReadOnly || !model.hasChecked">コマ割実行</button>
  <!-- button 他生協へコピー -->
  <button #btn_copyCoops class='btn-secondary' (click)="copyCoops()" [tabindex]="0"
    [disabled]="!model.isEditable || isPermittedReadOnly">他生協へコピー</button>
  <!-- button CSV出力 -->
  <button #btn_OutputCsv class='btn-secondary' (click)="outputCsv()" [tabindex]="0"
    [disabled]="!model.searchedMediumType">CSV出力</button>
  <!-- button 設定 -->
  <button #btn_RegistPage class='btn-primary' (click)="registPage()" [tabindex]="0"
    [disabled]="!model.isEditable || isPermittedReadOnly">設定</button>
</footer>